export enum HttpClientObserveEnum {
  BODY = 'body',
  RESPONSE = 'response',
  EVENTS = 'events'
}
